import * as React from "react"

const SvgComponent = ({ height = "20px", width = "20px", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox= "0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.462 0 0 4.462 0 10s4.462 10 10 10 10-4.462 10-10S15.538 0 10 0Z"
      fill="#FA3C30"
    />
    <path
      d="M6.574 14.354a.74.74 0 0 1-.524-1.264l7.04-7.04a.74.74 0 1 1 1.048 1.047l-7.04 7.04a.738.738 0 0 1-.524.216Zm7.04 0a.738.738 0 0 1-.523-.217l-7.04-7.04a.74.74 0 0 1 1.047-1.048l7.04 7.04a.74.74 0 0 1-.524 1.264Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.2}
    />
  </svg>
)

export default SvgComponent